import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm">
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-1.5">
          {index > 0 && (
            <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
          )}
          {item.href ? (
            <Link
              to={item.href}
              className="text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-700 font-medium whitespace-nowrap">
              {item.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}